import { render, staticRenderFns } from "./FrameNew.vue?vue&type=template&id=9b45f3ec&scoped=true&"
import script from "./FrameNew.vue?vue&type=script&lang=js&"
export * from "./FrameNew.vue?vue&type=script&lang=js&"
import style0 from "./FrameNew.vue?vue&type=style&index=0&id=9b45f3ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b45f3ec",
  null
  
)

export default component.exports